module.exports = __webpack_public_path__ + "static/media/promo-cta-background-2.c214fe39.jpg";